export default __webpack_public_path__ + "static/media/plan-seat.074a8cd7.svg";